import { useFetcher } from "@remix-run/react";
import { useCallback, useEffect, useRef } from "react";
export function useDebounceFetcher() {
    let timeoutRef = useRef();
    useEffect(() => {
        // no initialize step required since timeoutRef defaults undefined
        let timeout = timeoutRef.current;
        return () => {
            if (timeout)
                clearTimeout(timeout);
        };
    }, []);
    let fetcher = useFetcher();
    // Clone the original submit to avoid a recursive loop
    const originalSubmit = fetcher.submit;
    fetcher.submit = useCallback((target, { debounceTimeout = 0, ...options } = {}) => {
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        if (!debounceTimeout || debounceTimeout <= 0) {
            return originalSubmit(target, options);
        }
        timeoutRef.current = setTimeout(() => {
            originalSubmit(target, options);
        }, debounceTimeout);
    }, [originalSubmit]);
    return fetcher;
}
